import { render, staticRenderFns } from "./icon-info.vue?vue&type=template&id=c024b042&"
import script from "./icon-info.vue?vue&type=script&lang=js&"
export * from "./icon-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports